import { Component, HostListener, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { TranslateService } from '../../../services/translate.service';

@Component({
  selector: 'app-like-checkbox',
  templateUrl: './like-checkbox.component.html',
  styleUrls: ['./like-checkbox.component.scss'],
})
export class LikeCheckboxComponent {
  @Input()
  public fc: UntypedFormControl;

  @HostListener('click', ['$event'])
  public onClick(event: MouseEvent): void {
    event.stopPropagation();
  }

  get title(): string {
    return `${TranslateService.translate(
      this.fc.value ? 'like-checkbox-checked' : 'like-checkbox-not-checked'
    )}`;
  }
}
